import React from "react";

function UserChat({ data }) {
  // console.log(data);

  return (
    <>
      {data ? (
        <div className="">
          <div dir="rtl" className="w-fit max-w-[25rem] ml-auto ">
            <div className="text-white bg-primary  text-right py-[10px] px-[15px] rounded-l-lg rounded-b-lg">
              {data?.content}
            </div>
            <div dir="ltr" className="text-left text-sm py-1 ">
              {new Date(data.created_at).toLocaleTimeString([], {
                hour: "2-digit",
                minute: "2-digit",
              })}
            </div>
          </div>
        </div>
      ) : (
        ""
      )}
    </>
  );
}

export default UserChat;
